import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';



@Component({
  selector: 'app-pdf-viewer-container',
  templateUrl: './pdf-viewer-container.component.html',
  styleUrls: ['./pdf-viewer-container.component.css']
})
export class PdfViewerContainerComponent implements OnInit {
  pdfUrl: any;

  constructor(
              private route: ActivatedRoute, 
              private router: Router, 
              private sanitizer: DomSanitizer
    ) {}



  ngOnInit(): void {
    // Obtiene los parámetros de consulta de la URL
    this.route.queryParams.subscribe((params) => {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(params['url'])  //params['url'] || '';
    });
  }
  

}
